// Gladiator names ported from Java Gladiator.java
// Fantasy-themed surnames used to generate gladiator names

export const GLADIATOR_NAMES: string[] = [
  'Ackerman', 'Adlam', 'Admer', 'Aeargalad', 'Aglargalad',
  'Alaway', 'Allston', 'Ann', 'Annuamon', 'Armstrong',
  'Athol', 'Atteridge', 'Baldree', 'Ball', 'Balston',
  'Bain', 'Barrow', 'Baxter', 'Bean', 'Bellman',
  'Berwick', 'Blackden', 'Blain', 'Bliss', 'Birch',
  'Bostel', 'Buck', 'Bullock', 'Bywater', 'Clapp',
  'Clayman', 'Cobb', 'Coe', 'Combe', 'Conner',
  'Cragg', 'Crand', 'Crane', 'Crease', 'Darling',
  'Death', 'Deekes', 'Diplock', 'Dolg', 'Dolittle',
  'Dove', 'Drake', 'Dreng', 'Edhelgul', 'Elm',
  'Elvey', 'Falassarn', 'Fairfax', 'Fawke', 'Fimbul',
  'Flói', 'Garey', 'Geldard', 'Gillebrank', 'Gim',
  'Glew', 'Golightly', 'Gooday', 'Gossip', 'Gotobed',
  'Gripp', 'Gro', 'Grout', 'Gulgalad', 'Gwaelor',
  'Hackwood', 'Hagan', 'Haim', 'Halstead', 'Hammer',
  'Hardwick', 'Hattrick', 'Havelock', 'Herald', 'Herrick',
  'Hill', 'Hirion', 'Hone', 'Ithilhen', 'Knape',
  'Lane', 'Lang', 'Lark', 'Lymburner', 'Kelman',
  'Makepeace', 'Maples', 'Menelbar', 'Merriman', 'Nauredain',
  'Nauriel', 'Naylor', 'Nimthoniel', 'Norhtri', 'Oldacre',
  'Oldman', 'Palandring', 'Pile', 'Rea', 'Reeve',
  'Rimer', 'Rogalad', 'Root', 'Ruffet', 'Sacker',
  'Saffell', 'Seedman', 'Shakelance', 'Shinner', 'Short',
  'Shorthose', 'Singer', 'Smith', 'Spare', 'Stack',
  'Stallwood', 'Staple', 'Startup', 'Stump', 'Suthri',
  'Swift', 'Tapper', 'Tate', 'Tazelaar', 'Tegg',
  'Theobald', 'Thin', 'Thurkil', 'Þófr', 'Þjófr',
  'Threadgold', 'Tough', 'Truce', 'Tumman', 'Twiceaday',
  'Underwood', 'Unwin', 'Ward', 'Webster', 'Whitehead',
  'Wickfield', 'Widdows', 'Wildboar', 'Willgrass', 'Wine',
  'Winder', 'Wiseman', 'Woodey', 'Wolf', 'Yard',
  'Yate', 'Yatman',
];

// Get a random gladiator name
export function getRandomGladiatorName(): string {
  return GLADIATOR_NAMES[Math.floor(Math.random() * GLADIATOR_NAMES.length)];
}

// AI team names from Game.java
export const AI_TEAM_NAMES = {
  DIV_1: ['Kaaosvoima', 'Auringon soturit', 'Kuun Sotilaat', 'Pimeän Ruhtinaat'],
  DIV_2: ['Synkät Valtiaat', 'Sormusritarit', 'Olorin Lordit', 'Valon Vartijat'],
  DIV_3: ['Karhunkaatajat', 'Verikoirat', 'Harmaat Sudet', 'Hainhampaat'],
  DIV_4: ['Tomunpurijat', 'Varomattomat', 'Malttamattomat'], // Player fills slot 4
} as const;
